import { motion } from "framer-motion";
import { useIsMobile } from "../hooks/useIsMobile";
import { CrownMark } from "./CrownMark";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => {
  const mobile = useIsMobile();
  return (
    <motion.div
      className={className}
      initial={mobile ? { opacity: 0, y: 16 } : { opacity: 0, y, filter: "blur(12px)" }}
      whileInView={mobile ? { opacity: 1, y: 0 } : { opacity: 1, y: 0, filter: "blur(0px)" }}
      viewport={{ once: true, margin: mobile ? "-40px" : "-80px" }}
      transition={{ duration: mobile ? 0.5 : 0.85, delay: mobile ? Math.min(delay, 0.1) : delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const Overline = ({ children, className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 uppercase text-xs tracking-[0.25em] font-bold text-neon ${className}`}>
    <CrownMark className="h-3.5" animate={false} />
    <span className="h-px w-5 bg-neon/60" />
    {children}
  </span>
);
